<svg
  width="32"
  height="32"
  viewBox="0 0 32 32"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    d="M16.8 8C16.8 7.55817 16.4418 7.2 16 7.2C15.5582 7.2 15.2 7.55817 15.2 8L16.8 8ZM15.4343 25.5657C15.7467 25.8781 16.2533 25.8781 16.5657 25.5657L21.6569 20.4745C21.9693 20.1621 21.9693 19.6556 21.6569 19.3431C21.3444 19.0307 20.8379 19.0307 20.5255 19.3431L16 23.8686L11.4745 19.3431C11.1621 19.0307 10.6556 19.0307 10.3431 19.3431C10.0307 19.6556 10.0307 20.1621 10.3431 20.4745L15.4343 25.5657ZM15.2 8L15.2 25L16.8 25L16.8 8L15.2 8Z"
    fill="#7A89B0"
    fill-opacity="0.4"
  />
</svg>
